import { useCurrentCompanyNameKey } from '@/hooks/useCurrentCompanyNameKey'
import {
  useCurrentUserV1Query,
  useCurrentUserV3Query,
} from '@/queries/user/userQueries'
import { computed, type ComputedRef } from 'vue'

export const useSelfCertification = () => {
  const companyNameKey = useCurrentCompanyNameKey()
  const { data: currentUser } = useCurrentUserV1Query(companyNameKey)
  const { data: currentUserV3 } = useCurrentUserV3Query(companyNameKey)

  const canSelfCertify: ComputedRef<boolean> = computed(
    () => currentUserV3.value?.data?.attributes?.can_self_certify ?? true
  )

  const canCertifyUser = (
    targetUserId: string | number | null | undefined
  ): boolean => {
    const actingId = currentUser.value?.id

    if (actingId == null || targetUserId == null) return true
    if (String(actingId) !== String(targetUserId)) return true

    return canSelfCertify.value
  }

  return { canCertifyUser }
}
